<template>
    <button
        :type="type"
        :class="`app-button ${getClass} ${stateClass}`"
        @click.prevent="handleClick"
        :disabled="loading || disabled"
    >
        <span v-if="!loading">
            <slot />
        </span>
        <span v-else>
            <i class="fa fa-circle-notch fa-spin" />
        </span>
    </button>
</template>

<script>
export default {
    props: {
        loading: {
            type: Boolean,
            default: false,
        },
        type: {
            type: String,
            default: "button",
            validator: (value) => ["button", "submit"].includes(value),
        },
        btnStyle: {
            type: 'outline' | 'solid',
            default: "solid",
        },
        full: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        handleClick() {
            this.$emit("click");
        },
    },
    computed: {
        getClass() {
            var classes = this.$props.full ? "w-full" : "w-64";

            switch (this.$props.btnStyle) {
                case "outline":
                    return `${classes} bg-btn-new-white-300 hover:bg-white text-primary font-semibold py-5 rounded border border-primary`;
                case "solid":
                    return `${classes} bg-primary-700 hover:primary-300 text-white font-semibold py-5 rounded`;
            }
        },
        stateClass() {
            return (this.loading || this.disabled) ? "opacity-50 cursor-not-allowed" : "";
        },
    },
};
</script>
